import { Component } from '@mycolorway/tao';
import { MDCMenuSurfaceFoundation, MDCMenuSurface, Corner } from '@material/menu-surface';
import { closest } from 'next/javascripts/modules/dom';
import Sortable from 'sortablejs';
import $ from 'jquery';
import eventListenerMixin from 'next/javascripts/mixins/event-listener-mixin';
import 'next/stylesheets/components/portfolio/fields.scss';

Component('tr-portfolio-fields', {
  mixins: [eventListenerMixin],
  properties: {
    openOnReady: {
      type: Boolean,
      default: true,
    },
    submitUrl: String,
  },

  connected() {
  },

  ready() {
    this.initMenuSurface();
    this.initSortable();

    this.listenTo(
      this.querySelector('.menu-surface-anchor'),
      'click', () => this.toggleOpen(),
    );

    this.listenTo(this.mdcMenuSurface, {
      'MDCMenuSurface:opened': () => {
        this.initialFields = this.getFields();
      },
      'MDCMenuSurface:closed': this.handleMenuSurfaceClosed.bind(this),
    });
  },

  disconnected() {
    this.stopListening();
    if (this.sortable) this.sortable.destroy();
    if (this.mdcMenuSurface) this.mdcMenuSurface.destroy();
  },

  initMenuSurface() {
    this.menuSurfaceRoot = this.querySelector('.mdc-menu-surface');
    this.mdcMenuSurface = new MDCMenuSurface(this.menuSurfaceRoot);
    this.mdcMenuSurface.setAnchorCorner(Corner.BOTTOM_LEFT);
    this.mdcMenuSurface.setMenuSurfaceAnchorElement(this.querySelector('.menu-surface-anchor'));

    // eslint-disable-next-line no-underscore-dangle
    this.mdcMenuSurface
      .foundation_.handleBodyClick = function handleBodyClick(event) {
        if (!closest(event.target, 'body > .wrapper')) return;
        MDCMenuSurfaceFoundation.prototype.handleBodyClick.call(this, event);
      };

    if (this.openOnReady) {
      this.toggleOpen(true);
      this.openOnReady = false;
    }
  },

  initSortable() {
    this.sortable = Sortable.create(this.querySelector('.portfolio-fields'), {
      animation: 0,
      draggable: '.portfolio-field-item',
      handle: '.sortable-handle',
      onChoose: () => this.classList.add('sorting'),
      onUnchoose: () => this.classList.remove('sorting'),
      onEnd: () => this.classList.remove('sorting'),
      forceFallback: (window.gon && window.gon.sortableFallback) || false,
    });
  },

  toggleOpen(open = !this.mdcMenuSurface.open) {
    this.mdcMenuSurface.open = open;
  },

  getFields() {
    return Array.from(
      this.querySelectorAll('.portfolio-fields .portfolio-field-item'),
    ).map((item) => {
      const { portfolioFieldId } = item.dataset;
      const { checked: enabled } = item.querySelector('tr-switch-field');
      return { portfolioFieldId, enabled };
    });
  },

  handleMenuSurfaceClosed() {
    const fields = this.getFields();

    const fieldIds = fields.map(f => f.portfolioFieldId).join(',');
    const initialFieldIds = this
      .initialFields.map(f => f.portfolioFieldId).join(',');

    const fieldStatuses = fields.map(f => f.enabled).join(',');
    const initialFieldStatuses = this
      .initialFields.map(f => f.enabled).join(',');

    if (fieldIds !== initialFieldIds || fieldStatuses !== initialFieldStatuses) {
      $.ajax({
        url: this.submitUrl,
        method: 'post',
        data: {
          portfolios: {
            fields: fields.map(field => (
              { field_id: field.portfolioFieldId, enabled: field.enabled }
            )),
          },
        },
        dataType: 'script',
      });
    }
  },
});
